'use strict';

const _=require('pulsar-utils/dist-es6/_');

const reusableEmptyScope=Object.freeze({});
const _emptyArray=[];let

BaseDirective=class BaseDirective{
static get type(){
return'directive';
}

get objectBindings(){
return _emptyArray;
}
get textBindings(){
return _emptyArray;
}
get functionBindings(){
return _emptyArray;
}
get restrict(){
throw new Error('please implement restrict');
}

factory(){
const templateCount=[this.templateUrl,this.template].filter(t=>_.exists(t)).length;
const directiveName=this.constructor.name;

const logFormatter=msg=>`[PULSAR] [${directiveName}] ${msg}`;

if(templateCount>1){
throw new Error(logFormatter('cannot specify both "templateUrl" and "template"'));
}

let scope={};
if(_.exists(this.optionalObjectBindings)){
_loopCheckAndAttachBindings(scope,this.optionalObjectBindings,'=?',logFormatter);
_loopCheckAndAttachBindings(scope,this.objectBindings,'=',logFormatter);
}else{
_loopCheckAndAttachBindings(scope,this.objectBindings,'=?',logFormatter);
}
_loopCheckAndAttachBindings(scope,this.textBindings,'@',logFormatter);
_loopCheckAndAttachBindings(scope,this.functionBindings,'&',logFormatter);

if(_.isEmpty(scope)){
scope=reusableEmptyScope;
}

return{
scope:scope,
restrict:this.restrict,
templateUrl:this.templateUrl,
template:this.template,
link:this.link};

}};


const _loopCheckAndAttachBindings=(scope,bindingArray,bindingOption,logFormatter)=>{
if(!bindingOption||!_.isString(bindingOption)){
throw new Error(`Binding option not supported: ${bindingOption}`);
}

for(const binding of bindingArray){
_warnIfNotCamelCase(binding,logFormatter);
scope[binding]=bindingOption;
}
};

const _warnIfNotCamelCase=(bindingName,logFormatter)=>{
const inCamelCase=_.camelCase(bindingName);

if(bindingName!==inCamelCase){
console.error(logFormatter(`Binding not in camel case, are you sure this was intended? Use hyphenated version in markup only: ${bindingName}`));
}
};

module.exports=BaseDirective;
//# sourceMappingURL=baseDirective.js.map
